export default __webpack_public_path__ + "media/login-img-2-patterns.d77d4cba.svg";